import React, { useState } from "react";
import api from "../../api";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [newsStatus, setNewsStatus] = useState(null); // null | "success" | "duplicate" | "error"
  const [newsLoading, setNewsLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setNewsLoading(true);
    setNewsStatus(null);
    try {
      const res = await api.post("/newsletter/subscribe", { email });
      const status = res.status === 200 ? "duplicate" : "success";
      setNewsStatus(status);
      if (status === "success") setEmail("");
    } catch {
      setNewsStatus("error");
    } finally {
      setNewsLoading(false);
    }
  };

  return (
    <footer className="w-full bg-background-dark text-background-light rounded-t-xl border-t border-primary/30">
      <div className="max-w-5xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <div className="font-display text-3xl mb-4 select-none">Pisu</div>
          <p className="text-sm font-light mb-4">
            Handcrafted desserts made with love and premium ingredients for your special moments.
          </p>
          <div className="flex space-x-4 text-xl">
            <a
              aria-label="Instagram"
              href="https://www.instagram.com/pisu.tn/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-pink-400 transition-colors"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              aria-label="Facebook"
              href="https://www.facebook.com/61557530745252/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-blue-400 transition-colors"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              aria-label="TikTok"
              href="https://www.tiktok.com/@pisu.tn"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
            >
              <i className="fab fa-tiktok"></i>
            </a>
            <a
              aria-label="YouTube"
              href="https://www.youtube.com/@Pisu-tn"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-red-400 transition-colors"
            >
              <i className="fab fa-youtube"></i>
            </a>
          </div>
        </div>
        <div>
          <h3 className="uppercase text-sm font-semibold mb-4 tracking-widest">
            Navigation
          </h3>
          <ul className="text-sm font-light space-y-3">
            <li><a className="hover:text-primary transition-colors" href="#home">Home</a></li>
            <li><a className="hover:text-primary transition-colors" href="#best-sellers">Best Sellers</a></li>
            <li><a className="hover:text-primary transition-colors" href="#our-story">Events</a></li>
            <li><a className="hover:text-primary transition-colors" href="#products">Products</a></li>
            <li><a className="hover:text-primary transition-colors" href="#community">Community</a></li>
            <li><a className="hover:text-primary transition-colors" href="#contact">Contact</a></li>
          </ul>
        </div>
        <div>
          <h3 className="uppercase text-sm font-semibold mb-4 tracking-widest">
            Contact Us
          </h3>
          <ul className="text-sm font-light space-y-3">
            <li>
              <i className="fas fa-map-marker-alt mr-2"></i> Tunis, laouina 2045
            </li>
            <li>
              <i className="fas fa-envelope mr-2"></i> pisu.contact@gmail.com
            </li>
            <li>
              <i className="fas fa-phone mr-2"></i> +216 94 088 487
            </li>
            <li>
              <i className="fas fa-clock mr-2"></i> 24/7 Availability
            </li>
          </ul>
        </div>
        <div>
          <h3 className="uppercase text-sm font-semibold mb-4 tracking-widest">
            Newsletter
          </h3>
          <p className="text-sm font-light mb-3">
            Subscribe to receive updates, access to exclusive deals, and more.
          </p>
          <form onSubmit={handleSubscribe}>
            <div className="flex">
              <input
                type="email"
                placeholder="Your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="bg-background-dark/50 border border-primary/20 rounded-l-lg px-3 py-2 text-sm w-full focus:outline-none focus:border-primary/50"
              />
              <button
                type="submit"
                disabled={newsLoading}
                className="bg-primary hover:bg-primary/90 text-white px-3 rounded-r-lg transition-colors disabled:opacity-60"
              >
                <i className="fas fa-paper-plane"></i>
              </button>
            </div>
            {newsStatus === "success" && (
              <p className="text-green-400 text-xs mt-2">You're subscribed!</p>
            )}
            {newsStatus === "duplicate" && (
              <p className="text-yellow-400 text-xs mt-2">Already subscribed.</p>
            )}
            {newsStatus === "error" && (
              <p className="text-red-400 text-xs mt-2">Something went wrong. Try again.</p>
            )}
          </form>
        </div>
      </div>
      <div className="border-t border-primary/10 py-6 text-center text-sm">
        <p>© {new Date().getFullYear()} Pisu — Savor Every Bite</p>
      </div>
    </footer>
  );
};

export default Footer;
